// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file guest/v1/product.proto (package guest.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProductPrice } from "./shop_pb";
import { file_guest_v1_shop } from "./shop_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guest/v1/product.proto.
 */
export const file_guest_v1_product: GenFile = /*@__PURE__*/
  fileDesc("ChZndWVzdC92MS9wcm9kdWN0LnByb3RvEghndWVzdC52MSJVChdHZXRQcm9kdWN0RGV0YWlsUmVxdWVzdBIPCgdzaG9wX2lkGAEgASgDEhIKCnByb2R1Y3RfaWQYAiABKAMSFQoNbGFuZ3VhZ2VfY29kZRgDIAEoCSJEChhHZXRQcm9kdWN0RGV0YWlsUmVzcG9uc2USKAoHcHJvZHVjdBgBIAEoCzIXLmd1ZXN0LnYxLlByb2R1Y3REZXRhaWwi0wQKDVByb2R1Y3REZXRhaWwSEgoKcHJvZHVjdF9pZBgBIAEoAxIVCg1sYW5ndWFnZV9jb2RlGAIgASgJEg8KB3Nob3BfaWQYAyABKAMSFAoMcHJvZHVjdF90eXBlGAQgASgJEhYKDmNvdXJzZV9vcl9zZWF0GAUgASgJEgwKBG5hbWUYBiABKAkSEwoLZGVzY3JpcHRpb24YByABKAkSGAoQaW5jbHVkZWRfaW5fY29zdBgIIAEoCRIcChRub3RfaW5jbHVkZWRfaW5fY29zdBgJIAEoCRIdChVtZWV0aW5nX3BsYWNlX2FkZHJlc3MYCiABKAkSDAoEbm90ZRgLIAEoCRISCgpjYW5fY2FuY2VsGAwgASgIEh4KFnN0b2NrX251bWJlcl9saW1pdF9taW4YDSABKAUSHgoWc3RvY2tfbnVtYmVyX2xpbWl0X21heBgOIAEoBRImCgZwcmljZXMYDyADKAsyFi5ndWVzdC52MS5Qcm9kdWN0UHJpY2USNgoPY2FuY2VsX3BvbGljaWVzGBAgAygLMh0uZ3Vlc3QudjEuUHJvZHVjdENhbmNlbFBvbGljeRIRCglpbWFnZV91cmwYESADKAkSFQoNaW1hZ2VfY2FwdGlvbhgSIAMoCRIbChNzaG9wX21pbl9wYXJ0eV9zaXplGBMgASgFEhsKE3Nob3BfbWF4X3BhcnR5X3NpemUYFCABKAUSGQoRc2hvcF90dXJuX2VuYWJsZWQYFSABKAgSHQoVc2hvcF90dXJuX3N0YXJ0X3RpbWVzGBYgAygJIk4KE1Byb2R1Y3RDYW5jZWxQb2xpY3kSHAoUY2FuY2VsbGVkX2JlZm9yZV9kYXkYASABKAUSGQoRY2FuY2VsbGF0aW9uX3JhdGUYAiABKAEyawoOUHJvZHVjdFNlcnZpY2USWQoQR2V0UHJvZHVjdERldGFpbBIhLmd1ZXN0LnYxLkdldFByb2R1Y3REZXRhaWxSZXF1ZXN0GiIuZ3Vlc3QudjEuR2V0UHJvZHVjdERldGFpbFJlc3BvbnNlQkdaRWdpdGh1Yi5jb20vZWJpc29sL3ZpYWplcm8vYmFja2VuZC9pbnRlcm5hbC9nZW4vcHJvdG8vZ3Vlc3QvdjE7Z3Vlc3R2MWIGcHJvdG8z", [file_guest_v1_shop]);

/**
 * @generated from message guest.v1.GetProductDetailRequest
 */
export type GetProductDetailRequest = Message<"guest.v1.GetProductDetailRequest"> & {
  /**
   * JapanTicket shopId (read_model.product.shop_id。必須)。
   *
   * @generated from field: int64 shop_id = 1;
   */
  shopId: bigint;

  /**
   * JapanTicket productId (read_model.product.product_id。必須)。
   *
   * @generated from field: int64 product_id = 2;
   */
  productId: bigint;

  /**
   * 表示言語コード (例: ja / en / zh-CN / zh-TW)。該当言語の行が無ければ en へフォールバックする。
   *
   * @generated from field: string language_code = 3;
   */
  languageCode: string;
};

/**
 * Describes the message guest.v1.GetProductDetailRequest.
 * Use `create(GetProductDetailRequestSchema)` to create a new message.
 */
export const GetProductDetailRequestSchema: GenMessage<GetProductDetailRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_product, 0);

/**
 * @generated from message guest.v1.GetProductDetailResponse
 */
export type GetProductDetailResponse = Message<"guest.v1.GetProductDetailResponse"> & {
  /**
   * 商品詳細 (read_model.product 由来)。
   *
   * @generated from field: guest.v1.ProductDetail product = 1;
   */
  product?: ProductDetail | undefined;
};

/**
 * Describes the message guest.v1.GetProductDetailResponse.
 * Use `create(GetProductDetailResponseSchema)` to create a new message.
 */
export const GetProductDetailResponseSchema: GenMessage<GetProductDetailResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_product, 1);

/**
 * ProductDetail は商品詳細 1 件 (read_model.product の採用言語行由来)。
 * 外部データの任意項目 (NULL あり得る列) は空文字 / 0 / false で返す。
 * 予約フォーム用の疎構造 (options / participant_input / product_questions) は
 * 商品詳細画面の表示対象外のため含めない (予約系 RPC で必要になった時点で追加する)。
 *
 * @generated from message guest.v1.ProductDetail
 */
export type ProductDetail = Message<"guest.v1.ProductDetail"> & {
  /**
   * JapanTicket productId (言語非依存の安定 ID)。
   *
   * @generated from field: int64 product_id = 1;
   */
  productId: bigint;

  /**
   * 採用された言語コード (指定言語 or フォールバック先の en)。
   *
   * @generated from field: string language_code = 2;
   */
  languageCode: string;

  /**
   * 所属店舗の JapanTicket shopId。
   *
   * @generated from field: int64 shop_id = 3;
   */
  shopId: bigint;

  /**
   * 商品種別 (例: 飲食コース)。
   *
   * @generated from field: string product_type = 4;
   */
  productType: string;

  /**
   * コース / 席のみ の区分。
   *
   * @generated from field: string course_or_seat = 5;
   */
  courseOrSeat: string;

  /**
   * 商品名。
   *
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * 商品説明。
   *
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * 料金に含まれるもの。
   *
   * @generated from field: string included_in_cost = 8;
   */
  includedInCost: string;

  /**
   * 料金に含まれないもの。
   *
   * @generated from field: string not_included_in_cost = 9;
   */
  notIncludedInCost: string;

  /**
   * 集合場所の住所。
   *
   * @generated from field: string meeting_place_address = 10;
   */
  meetingPlaceAddress: string;

  /**
   * 注意事項。
   *
   * @generated from field: string note = 11;
   */
  note: string;

  /**
   * キャンセル可否 (NULL は false で返す)。
   *
   * @generated from field: bool can_cancel = 12;
   */
  canCancel: boolean;

  /**
   * 予約可能な最小人数 (未設定は 0)。
   *
   * @generated from field: int32 stock_number_limit_min = 13;
   */
  stockNumberLimitMin: number;

  /**
   * 予約可能な最大人数 (未設定は 0)。
   *
   * @generated from field: int32 stock_number_limit_max = 14;
   */
  stockNumberLimitMax: number;

  /**
   * 価格配列 (read_model.product.prices 由来。shop.proto の ProductPrice を共用)。
   *
   * @generated from field: repeated guest.v1.ProductPrice prices = 15;
   */
  prices: ProductPrice[];

  /**
   * キャンセルポリシー配列 (read_model.product.cancel_policy 由来)。
   *
   * @generated from field: repeated guest.v1.ProductCancelPolicy cancel_policies = 16;
   */
  cancelPolicies: ProductCancelPolicy[];

  /**
   * 画像 URL 配列 (順序 = 表示順)。
   *
   * @generated from field: repeated string image_url = 17;
   */
  imageUrl: string[];

  /**
   * 画像キャプション配列 (image_url と同インデックスで対応)。
   *
   * @generated from field: repeated string image_caption = 18;
   */
  imageCaption: string[];

  /**
   * 所属店舗の予約可能人数の下限 (crud.tc_shop.min_party_size。未設定は 0)。
   *
   * @generated from field: int32 shop_min_party_size = 19;
   */
  shopMinPartySize: number;

  /**
   * 所属店舗の予約可能人数の上限 (crud.tc_shop.max_party_size。未設定は 0)。
   *
   * @generated from field: int32 shop_max_party_size = 20;
   */
  shopMaxPartySize: number;

  /**
   * 所属店舗の回転設定 on/off (crud.tc_shop.turn_enabled。TC 未登録の店舗は false)。
   * on のとき shop_turn_start_times の時刻のみ予約できる (JPTP_CANSEI-1665)。
   *
   * @generated from field: bool shop_turn_enabled = 21;
   */
  shopTurnEnabled: boolean;

  /**
   * 所属店舗の回転の開始時間 ("HH:MM"、昇順・重複なし。crud.tc_shop.turn_start_times)。
   * shop_turn_enabled=false のときは空。
   *
   * @generated from field: repeated string shop_turn_start_times = 22;
   */
  shopTurnStartTimes: string[];
};

/**
 * Describes the message guest.v1.ProductDetail.
 * Use `create(ProductDetailSchema)` to create a new message.
 */
export const ProductDetailSchema: GenMessage<ProductDetail> = /*@__PURE__*/
  messageDesc(file_guest_v1_product, 2);

/**
 * ProductCancelPolicy はキャンセルポリシー 1 件 (cancel_policy JSONB の要素構造。
 * Shop・商品データ同期_詳細設計 §4.1)。
 *
 * @generated from message guest.v1.ProductCancelPolicy
 */
export type ProductCancelPolicy = Message<"guest.v1.ProductCancelPolicy"> & {
  /**
   * 何日前からの適用か (例: 3 = 3 日前から)。
   *
   * @generated from field: int32 cancelled_before_day = 1;
   */
  cancelledBeforeDay: number;

  /**
   * キャンセル料率 (例: 1.0 = 100%)。
   *
   * @generated from field: double cancellation_rate = 2;
   */
  cancellationRate: number;
};

/**
 * Describes the message guest.v1.ProductCancelPolicy.
 * Use `create(ProductCancelPolicySchema)` to create a new message.
 */
export const ProductCancelPolicySchema: GenMessage<ProductCancelPolicy> = /*@__PURE__*/
  messageDesc(file_guest_v1_product, 3);

/**
 * ProductService はゲスト (案件アクセストークン保持者) 向けの商品 (コース) 情報参照を提供する。
 * 認証は Cognito を通さず、URL 由来の案件アクセストークンを x-case-token ヘッダで受け取り、
 * Guest 公開 Interceptor がハッシュ照合して案件・テナントを解決する (ADR-011 /
 * ゲストアプリの設計 §4・§5)。トークン不一致・失効は NotFound、期限切れは FailedPrecondition。
 * サービスはトークンで解決した 1 案件のスコープに閉じる (§5.1)。
 *
 * @generated from service guest.v1.ProductService
 */
export const ProductService: GenService<{
  /**
   * GetProductDetail は商品 (コース) の詳細情報を返す (ゲストアプリの設計 §5.2・§7)。
   * shop_id が案件の提案範囲 (case_item.proposal の対象店舗) に含まれるか、および
   * product_id が当該店舗のテナント取り扱い商品 (tenant_product) かを検証し、
   * 範囲外は存在を秘匿するため NotFound を返す。表示は指定言語を優先し、
   * 無ければ英語 (en) にフォールバックする。
   *
   * @generated from rpc guest.v1.ProductService.GetProductDetail
   */
  getProductDetail: {
    methodKind: "unary";
    input: typeof GetProductDetailRequestSchema;
    output: typeof GetProductDetailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guest_v1_product, 0);

